import {signal} from "@preact/signals-react"

export const shareOfSearchStatusIsEmpty = signal(false)
export const shareOfSearchStatusScoreFilters = signal({})

export const resetShareOfSearchStatus = () => {
    shareOfSearchStatusScoreFilters.value = {}
    shareOfSearchStatusIsEmpty.value = false
}